/** LCCTO workspace folders and related GitHub remotes. */

export const LCCTO_GITHUB_ORG = 'd1b1';
export const LCCTO_PLANNING_ORG = 'Low-Code-CTO';

export type LcctoRepo = {
  id: 'engine' | 'content' | 'booktime' | 'master-plan';
  label: string;
  folder: string;
  owner: string;
  repo: string;
  description: string;
};

export const LCCTO_REPOS: readonly LcctoRepo[] = [
  {
    id: 'engine',
    label: 'Engine',
    folder: 'engine-ui/',
    owner: LCCTO_GITHUB_ORG,
    repo: 'lccto-content-manager',
    description: 'Admin app, Supabase migrations, Inngest, Postmark',
  },
  {
    id: 'content',
    label: 'Content',
    folder: 'content/',
    owner: LCCTO_GITHUB_ORG,
    repo: 'new-me',
    description: 'Astro site, markdown content, distribute skill',
  },
  {
    id: 'booktime',
    label: 'BookTime',
    folder: 'calendar/',
    owner: LCCTO_PLANNING_ORG,
    repo: 'booktime',
    description: 'Public scheduling — book.stephansmith.me',
  },
  {
    id: 'master-plan',
    label: '5-year master plan',
    folder: '5-year-master-plan/',
    owner: LCCTO_PLANNING_ORG,
    repo: '5-year-master-plan',
    description: 'Long-term strategy and planning repo',
  },
] as const;

export function githubRepoUrl(owner: string, repo: string): string {
  return `https://github.com/${owner}/${repo}`;
}

export function githubRepoTreeUrl(owner: string, repo: string, branch = 'main'): string {
  return `${githubRepoUrl(owner, repo)}/tree/${branch}`;
}
